export const NAMESPACE = 'file';

export const SELENIUM_LOGFILE_NAME = 'log.json';
export const ESPRESSO_LOGFILE_NAME = 'native-log.json';
export const XCUITEST_LOGFILE_NAME = 'junit.xml';
export const DEVX_LOGFILE_NAME = 'console.log';

export const STATUS = {
  SUCCESS: 'SUCCESS',
  FAILURE: 'FAILURE',
  LOADING: 'LOADING',
  SKIPPED: 'SKIPPED',
};

export const EDS_SPECIFIC_FILENAMES = ['console.json'];

export const RDC_SPECIFIC_FILENAMES = ['appium.log', 'commands.json', 'device.log', 'xcuitest.log', 'network.har', 'crash.log'];

export const PARSE_LOG_MAX_SIZE = 25;

export const APP_FILTER_NAME = 'APP';
